import { useMemo } from "react";

import type { ModelsInfoTableProps } from "../../../../components/ModelsInfoTable";
import { ModelsInfoTableController } from "../../../../components/ModelsInfoTable";
import type { IAppMetrics } from "../../../../hooks/reactQueryHooks/useBilling";
import type { PlaygroundModel } from "../../../../hooks/reactQueryHooks/usePlayground";
import {
  formatCurrency,
  formatNumber,
} from "../../../../utils/NumbersFormatting";
export interface ApplicationsTableProps {
  tokenMetrics?: IAppMetrics;
  models: PlaygroundModel[] | undefined;
}

const ApplicationsTable: React.FC<ApplicationsTableProps> = ({
  tokenMetrics,
  models,
}) => {
  const { perModel: tableData } = tokenMetrics || ({} as IAppMetrics);
  const parsedTableData = useMemo<ModelsInfoTableProps>(() => {
    if (!models) return [];

    return Object.keys(tableData || {}).map(key => {
      const { cached, active, costSavings, cogCachePrice } = tableData[key];
      return {
        modelName:
          models?.find(({ model }) => model === key)?.displayName || key,
        tokens: {
          paid: formatNumber(active.inputTokens + active.outputTokens),
          free: formatNumber(cached.inputTokens + cached.outputTokens),
        },
        costSavings: formatCurrency(costSavings),
        totalCost: formatCurrency(cogCachePrice),
      };
    });
  }, [tableData, models]);

  return (
    <>
      <h4 className="billing-table-title">Usage breakdown by models:</h4>
      {parsedTableData.length ? (
        <ModelsInfoTableController tableData={parsedTableData} />
      ) : (
        <p>No data to display. Check back later.</p>
      )}
    </>
  );
};

export { ApplicationsTable };
